import { isNotDefined } from '@sgme/fp';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';
import { LiveUpdatableInput } from '@/App/tiles/Option/strategy/fields/LiveUpdatableInput.tsx';
import { selectOptionHedge, selectQuoteHedge } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId } from '@/store/option/state.ts';

type HedgeRateProps = {
  tileId: string;
  legId: LegId;
  className?: string;
};

export function HedgeRate({ tileId, legId, className }: HedgeRateProps) {
  const [checkOption] = useCheckOption();
  const { hedge, quoteHedge } = useOptionSelector((option) => {
    const quoteHedge = selectQuoteHedge(option, legId);
    const hedge = selectOptionHedge(option, legId);
    return {
      quoteHedge,
      hedge,
    };
  });

  if (isNotDefined(hedge)) {
    return <div />;
  }

  function onValueChange(hedgeRate: number | undefined | null) {
    if (isNotDefined(hedge)) {
      return;
    }
    checkOption({
      tileId,
      hedges: { legId: hedge.legId, rate: hedgeRate },
    });
  }

  return (
    <LiveUpdatableInput
      data-e2e="HedgeRate"
      liveValue={quoteHedge?.rateMid}
      editValue={hedge.rate}
      onChange={onValueChange}
      className={className}
    />
  );
}
